<template>
    <v-container :class="mobile ? 'pa-4' : 'pa-8'" fluid>
        <!-- Заголовок -->
        <v-row align="center" class="mb-4">
            <v-col>
                <h1 :class="mobile ? 'text-h6' : 'text-h4'" class="font-weight-bold">
                    <v-icon icon="mdi-calendar-clock" class="mr-2" color="primary" />
                    Расписание занятий
                </h1>
            </v-col>
            <v-col class="d-flex justify-end">


                <v-btn :href="$model.wwwroot" color="primary" prepend-icon="mdi-home-account">
                    На главную
                </v-btn>

            </v-col>
        </v-row>

        <!-- Offline banner -->
        <v-alert v-if="offline" type="error" variant="tonal" icon="mdi-wifi-off" class="mb-6">
            Нет соединения с интернетом. Показаны сохраненные данные.
        </v-alert>

        <!-- МОБИЛЬНЫЙ ВИД: Автокомплит -->
        <!--
        <div v-if="mobile">
            <v-autocomplete v-if="groups.length" v-model="selectedGroup" :items="groups" item-title="name"
                item-value="id" return-object clearable label="Поиск группы" hide-details placeholder="Например ПС-201"
                density="comfortable" prepend-inner-icon="mdi-magnify" variant="solo" rounded
                @update:modelValue="selectGroup">
           
                <template #item="{ props, item }">
                    <v-list-item v-bind="props" :subtitle="getDepName(item.department_id)" />
                </template>
</v-autocomplete>
<v-skeleton-loader v-else type="article"></v-skeleton-loader>
</div>
-->


        <!-- Недавние -->
        <div v-if="recentGroups.length" class="mt-4">
            <div class="text-overline mb-2">Недавние</div>
            <v-chip-group>
                <v-chip v-for="group in recentGroups" :key="group.id" @click="selectGroup(group)" color="primary"
                    variant="tonal">
                    {{ group.name }}
                </v-chip>
            </v-chip-group>
        </div>

        <!-- ДЕСКТОПНЫЙ ВИД: Сетка и Фильтры -->
        <v-row>
            <!-- Боковое меню или табы для филиалов -->
            <v-col :cols="mobile ? 12 : 3">
                <v-card variant="outlined" class="rounded-lg">
                    <v-list v-if="departments.length" :selected="selectedBranch"
                        @update:selected="selectedBranch = $event" mandatory color="primary">
                        <v-list-subheader>ФИЛИАЛЫ</v-list-subheader>
                        <v-list-item v-for="dep in departments" :key="dep.id" :value="dep.id" :title="dep.name"
                            rounded="lg" class="mb-1" />
                    </v-list>
                    <v-skeleton-loader v-else type="article"></v-skeleton-loader>
                </v-card>
            </v-col>

            <!-- Основная панель: Группы по курсам -->
            <v-col :cols="mobile ? 12 : 9">
                <div v-if="dynamicCourses.length">
                    <div v-for="course in dynamicCourses" :key="course" :class="[
                        'mb-10',
                        { 'd-flex align-center': !mobile },
                    ]">

                        <!-- Фиксированный заголовок курса -->
                        <div class="font-weight-bold text-h5 pt-1" style="min-width: 100px; flex-shrink: 0;">
                            <span v-if="course!=0">{{ course }} курс</span>
                        </div>

                        <!-- Контейнер для чипов с вертикальной чертой слева -->
                        <div :class="[
                            'd-flex flex-wrap ga-2 pl-4 ',
                            { 'border-s-lg': !mobile },
                        ]" style="border-color: rgba(0,0,0,0.12) !important;">
                            <v-chip v-for="group in getGroupsByCourse(course)" :key="group.id" size="large"
                                variant="outlined" color="primary" class="px-4 font-weight-medium group-chip"
                                @click="selectGroup(group)">
                                {{ group.name }}
                            </v-chip>
                        </div>

                    </div>
                </div>
                <v-skeleton-loader v-else type="article"></v-skeleton-loader>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { useDisplay } from 'vuetify'
import { procollegeStore } from 'moodleDir/procollege/lib/vue/store.js'
export default {
    name: 'GroupSearchPage',
    setup() {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data() {
        return {
            selectedGroup: null,
            groups: [],
            departments: [],
            selectedBranch: [],
            offline: !navigator.onLine,
            // недавние
            recentGroups: [],
        }
    },

    computed: {
        // Динамический список курсов на основе данных
        dynamicCourses() {
            const courses = this.filteredGroups.map(g => g.year);
            return [...new Set(courses)].sort((a, b) => a - b);
        },
        currentBranchId() {
            return this.selectedBranch.length > 0 ? this.selectedBranch[0] : null;
        },
        isMobile() {
            //для $vuetify.display.mobile md уже мобильный девайс
            return this.$vuetify.display.mobile && this.$vuetify.display.name == 'xs'
        },
        // Группы, отфильтрованные по филиалу
        filteredGroups() {
            if (!this.currentBranchId) {
                return [];
            }
            return this.groups.filter(g => g.department_id == this.currentBranchId);
        },
    },
    watch: {
        selectedBranch(newVal) {
            if (newVal && newVal.length > 0) {
                const store = new procollegeStore();
                store.set('timetable:lastBranch', newVal[0], false);
            }
        }
    },
    async created() {
        let store = new procollegeStore();
        // 1. Проверяем, выбрана ли группа ранее. Если да — сразу редирект
        const savedGroupId = await store.get('timetable:lastGroup');
        if (savedGroupId) {
            return this.$router.push(`/group/${savedGroupId}`);
        }
        try {
            let departments = await store.get('departments')
            if (!departments || !departments.length) {
                await this.getDepartments();
                store.set('departments', this.departments);//one week ttl
            } else {
                this.departments = departments;
            }
            // 3. Восстанавливаем последний выбранный филиал
            const lastBranch = await store.get('timetable:lastBranch');
            if (lastBranch) {
                this.selectedBranch = [lastBranch];
            } else if (this.departments.length > 0) {
                this.selectedBranch = [this.departments[0].id];
            }

            //let groups = await store.get('groups')
            //if (!groups || !groups.length) {
            await this.getGroups()
            //   store.set('groups', this.groups);//one week ttl
            //} else {
            //    this.groups = groups;
            //}

            //load Recent Groups
            let recent = await store.get('timetable:recentGroup')
            if (recent) {
                this.recentGroups = recent;
            }
        } finally {
        }
    },
    mounted() {
        window.addEventListener('online', () => this.offline = false);
        window.addEventListener('offline', () => this.offline = true);
    },
    beforeUnmount() {
        window.removeEventListener('online', () => this.offline = false)
        window.removeEventListener('offline', () => this.offline = true)
    },
    // Этот хук вызывается перед тем, как подтвержден переход на этот роут
    async beforeRouteEnter(to, from, next) {
        const store = new procollegeStore();
        // Проверяем: если предыдущий роут был страницей группы (любой)
        // RegExp проверяет соответствие паттерну /group/123
        const isComingFromGroup = /^\/group\/\d+/.test(from.path);
        if (isComingFromGroup) {
            // Пользователь намеренно вернулся с расписания -> сбрасываем авто-редирект
            await store.remove('timetable:lastGroup');
        }

        next(vm => {
            // Внутри next(vm => ...) можно вызвать методы компонента, если нужно
            // Но редирект в created() сработает сам, если мы НЕ удалили ключ выше
        });
    },
    methods: {
        getGroupsByCourse(course) {
            return this.filteredGroups.filter(g => g.year == course);
        },
        getDepName(id) {
            return this.departments.find(d => d.id == id)?.name || '';
        },

        saveRecent(group) {
            let store = new procollegeStore();

            const filtered = this.recentGroups.filter(g => g.id !== group.id)
            const updated = [group, ...filtered].slice(0, 5)

            store.set('timetable:recentGroup', updated, false);//one week ttl
            this.recentGroups = updated
        },

        async getGroups() {
            return this.axios.post(this.$model.wwwroot +
                "/procollege/core_procollege/helpers/rest/getGroups",
            ).then((response) => {
                this.groups = response.data;
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
            });
        },
        selectGroup(group) {
            const store = new procollegeStore();

            // Сохраняем ID выбранной группы (навсегда или с большим TTL)
            store.set('timetable:lastGroup', group.id, false);

            // Также сохраняем текущий филиал, чтобы при сбросе группы он остался
            if (group.department_id) {
                store.set('timetable:lastBranch', group.department_id, false);
            }

            this.saveRecent(group)
            this.$router.push(`/group/${group.id}`)
        },
        async getDepartments() {
            return this.axios
                .post(
                    this.$model.wwwroot +
                    "/procollege/core_procollege/helpers/rest/getDepartments",
                )
                .then((response) => {
                    this.departments = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.group-chip {
    transition: all 0.2s ease-in-out !important;
    cursor: pointer;
    border-width: 1.5px !important;
    /* Делаем рамку чуть толще */
}

.group-chip:hover {
    /* Смещение вверх для эффекта "кнопки" */
    transform: translateY(-3px);
    /* Делаем тень под чипом */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
    /* Закрашиваем фон при наведении (цветом secondary из темы) */
    background-color: rgb(var(--v-theme-secondary)) !important;
    color: white !important;
    /* Убираем прозрачность рамки */
    border-color: transparent !important;
}
</style>